export default __webpack_public_path__ + "static/media/payroll-outline-16px.1189119e.svg";